module.exports = __webpack_public_path__ + "media/images/icon__arrow-right@2x-fdca0e4c3fad5396f410bf2354382d11.png";